import React, { useEffect, useState } from "react";
import RentRequestAPI from "../../modules/rentRequestAPI";
import "./RentRequest.css";

const RentRequest = () => {
  const [rentRequests, setRentRequests] = useState(() => []);
  const [filteredRentRequests, setFilteredRentRequests] = useState(() => []);

  function getRentRequests() {
    RentRequestAPI.getRentRequests().then((res) => {
      setRentRequests(res.rent_requests);
      setFilteredRentRequests(res.rent_requests);
    });
  }

  function search(event) {
    const searchTerm = event.target.value;
    if (searchTerm === "") setFilteredRentRequests(rentRequests);
    else {
      const filteredRequests = [];
      rentRequests.forEach((request) => {
        if (
          request.item_request.toLowerCase()?.includes(searchTerm) ||
          request.size.toLowerCase()?.includes(searchTerm) ||
          request.quantity.toString()?.includes(searchTerm) ||
          request.gender.toLowerCase()?.includes(searchTerm) ||
          request.created_at.includes(searchTerm) ||
          request.email_address.toLowerCase()?.includes(searchTerm)
        )
          filteredRequests.push(request);
      });
      setFilteredRentRequests(filteredRequests);
    }
  }

  useEffect(() => {
    getRentRequests();
  }, []);

  return (
    <div className="rent-request-main">
      <div className="rent-request-search-container">
        <input
          type="text"
          placeholder="Search rent requests..."
          className="rent-request-search-input"
          onChange={(value) => search(value)}
        ></input>
      </div>
      <div className="rent-request-table">
        <table>
          <tbody>
            <tr>
              <th>Item Request</th>
              <th>Size</th>
              <th>Quantity</th>
              <th>Gender</th>
              <th>Created at</th>
              <th>Email</th>
            </tr>
            {filteredRentRequests.map((request, index) => {
              return (
                <tr key={index}>
                  <td>{request.item_request}</td>
                  <td>{request.size}</td>
                  <td>{request.quantity}</td>
                  <td>{request.gender}</td>
                  <td>{request.created_at}</td>
                  <td>{request.email_address}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RentRequest;
